import { render } from "./CrmDealKanbanDealDataModal.vue?vue&type=template&id=130f007e&scoped=true"
import script from "./CrmDealKanbanDealDataModal.vue?vue&type=script&lang=js"
export * from "./CrmDealKanbanDealDataModal.vue?vue&type=script&lang=js"

import "./CrmDealKanbanDealDataModal.vue?vue&type=style&index=0&id=130f007e&scoped=true&lang=css"
import "./CrmDealKanbanDealDataModal.vue?vue&type=style&index=1&id=130f007e&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130f007e"]])

export default __exports__